import { Stack, Typography } from "@mui/material";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

export const DeleteReccuringDateDialog = (props) => {
  const { handleRemoveRecurringDate, confirmDeleteRecurringDates } = props;

  return (
    <>
      <Stack padding="12px 24px 0px 24px" gap="16px">
        <Typography fontWeight={600} fontSize="16px">
          Are you sure you want to remove both the recurring dates and custom
          dates for the template?
        </Typography>
        <Typography>
          These dates will be removed from your production schedule. You can add
          dates again later.
        </Typography>
      </Stack>
      <CustomDialogFooter
        handleClose={() => handleRemoveRecurringDate(false)}
        onSubmit={confirmDeleteRecurringDates}
        submitButton="Delete"
        cancelButton="Close"
        submitButtonColor="error"
      />
    </>
  );
};
